import { useState, useEffect } from 'react';
import { notificationService } from '@/services/notificationService';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Hook para gestionar notificaciones de disponibilidad
 */
export const useNotifications = () => {
  const { user } = useAuth();
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const [hasPermission, setHasPermission] = useState(false);

  useEffect(() => {
    // Verificar permisos al cargar
    setHasPermission(notificationService.hasPermission());
    
    // Verificar si las notificaciones ya están activas
    if (user?.id) {
      const yaActivadas = notificationService.tieneNotificacionesProgramadas(user.id);
      setNotificationsEnabled(yaActivadas);
      
      // Solo activar si no están ya programadas
      if (!yaActivadas && notificationService.hasPermission()) {
        activarNotificaciones();
      }
    }
  }, [user]);

  /**
   * Activa las notificaciones para el usuario actual
   */
  const activarNotificaciones = async (): Promise<boolean> => {
    if (!user?.id) return false;

    try {
      const success = await notificationService.activarNotificaciones(user.id);
      setNotificationsEnabled(success);
      setHasPermission(success);
      return success;
    } catch (error) {
      console.error('Error activando notificaciones:', error);
      return false;
    }
  };

  /**
   * Desactiva las notificaciones
   */
  const desactivarNotificaciones = (): void => {
    notificationService.desactivarNotificaciones();
    setNotificationsEnabled(false);
  };

  /**
   * Solicita permisos de notificación
   */
  const solicitarPermisos = async (): Promise<boolean> => {
    const granted = await notificationService.requestPermission();
    setHasPermission(granted);
    return granted;
  };

  return {
    notificationsEnabled,
    hasPermission,
    activarNotificaciones,
    desactivarNotificaciones,
    solicitarPermisos
  };
};